import axios from 'axios';

import * as utils from '../utils/utils.js';

export const fetchSession = async (session_id) => {
    var session_url = utils.backendUrl() + `/session?session_id=${session_id}`;

    try {
        const response = await axios.get(session_url, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.data.session;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
